import { Options } from './option.model';

export const USER_STATUS: Options = [
  { value: 1, label: 'yes include me' },
  { value: 0, label: 'no thanks...' }
];

